import axios from 'api/axiosInstance';
import { GroundTruth, PromptType, Patient } from 'common/models/types';

interface ApiResponse<T> {
  error: number;
  data: T;
}

interface PatientsWithGroundTruthResponse {
  patientIds: number[];
  patients: Patient[];
}

export interface CreateGroundTruthDto {
  patientId: number;
  promptType: PromptType | string;
  expectedContent: string;
}

export interface UpdateGroundTruthDto {
  patientId: number;
  promptType: PromptType | string;
  expectedContent: string;
}

export interface GroundTruthFilters {
  patientId?: number;
  promptType?: PromptType;
  includeDeleted?: boolean;
}

export const groundTruthApi = {
  // 목록 조회
  findAll: (filters?: GroundTruthFilters) => 
    axios.get<ApiResponse<GroundTruth[]>>('/api/v1/admin/ai-review-evaluation/ground-truths', { 
      params: filters 
    }),

  // GT가 있는 환자 목록 조회
  findPatientsWithGroundTruth: (params?: { promptType?: string }) =>
    axios.get<ApiResponse<PatientsWithGroundTruthResponse>>('/api/v1/admin/ai-review-evaluation/ground-truths/patients', { params }),

  // 상세 조회
  findOne: (id: number) =>
    axios.get<ApiResponse<GroundTruth>>(`/api/v1/admin/ai-review-evaluation/ground-truths/${id}`),

  // 생성
  create: (data: CreateGroundTruthDto) =>
    axios.post<ApiResponse<GroundTruth>>('/api/v1/admin/ai-review-evaluation/ground-truths', data),

  // 수정
  update: (id: number, data: UpdateGroundTruthDto) =>
    axios.put<ApiResponse<GroundTruth>>(`/api/v1/admin/ai-review-evaluation/ground-truths/${id}`, data),

  // 삭제
  remove: (id: number) =>
    axios.delete<ApiResponse<void>>(`/api/v1/admin/ai-review-evaluation/ground-truths/${id}`),
};